import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CallsComponent} from './calls-list/calls.component';
import {CallsDialogComponent} from './calls-list/calls-dialog/calls-dialog.component';
import {ArmTableModule} from '../components/arm-table/arm-table.module';
import {LayoutModule} from '../components/layout/layout.module';
import {InfraModule} from 'ac-infra';
import {MaterialModule} from '../material.module';
import {FormsModule} from '@angular/forms';
import {DialogModule} from '../components/dialog/dialog.module';
import {NetworkDiagramModule} from '../utils/network-diagram/network-diagram.module';
import {ContextMenuModule} from '@perfectmemory/ngx-contextmenu';
import {ManipulationGridModule} from '../components/manipulation-grid/manipulation-grid.module';
import {DynamicBlacklistComponent} from './dynamic-blacklist/dynamic-blacklist.component';
import {ClientFilterModule} from '../components/client-filter/client-filter.module';
import {ActionBarModule} from '../components/action-bar/action-bar.module';



@NgModule({
  declarations: [CallsComponent, CallsDialogComponent, DynamicBlacklistComponent],
  imports: [
    CommonModule,
    CommonModule,
    ArmTableModule,
    LayoutModule,
    InfraModule,
    MaterialModule,
    FormsModule,
    DialogModule,
    NetworkDiagramModule,
    ContextMenuModule,
    ManipulationGridModule,
    ClientFilterModule,
    ActionBarModule
  ]
})
export class CallsModule { }
